/* historIA storefront behaviour (from the approved static page). Strings come from the theme's locale via
   window.HISTORIA, so the same file serves Hebrew and French. */
(() => {
  const H = window.HISTORIA || {};
  const wa = text => 'https://wa.me/' + H.phone + '?text=' + encodeURIComponent(text);

  /* The child's name on the cover, as the visitor types it. Long names shrink to fit. */
  const inp = document.getElementById('try-name'), out = document.querySelector('[data-name]');
  if (inp && out) {
    const fit = t => { const n = [...t].length; out.style.setProperty('--name-size', (n <= 5 ? 11 : Math.max(5.5, 11 * 5 / n)) + 'cqi'); };
    inp.addEventListener('input', () => { const t = inp.value.trim() || H.defName; out.textContent = t; fit(t); });
  }

  /* Every WhatsApp link carries its prefilled message (the number is only ever a link, never text). */
  document.querySelectorAll('a[data-wa]').forEach(a => { a.href = wa(a.dataset.wa || H.waMsg); });

  /* Floating WhatsApp: visible once the hero is scrolled past, hidden while the order band is on screen.
     The message uses the name the visitor typed on the cover, if any. */
  const pill = document.getElementById('wa-float'), bar = document.getElementById('sticky-cta') || pill, hero = document.querySelector('.hero'), order = document.getElementById('order');
  if (pill) {
    const link = () => { const n = inp && inp.value.trim(); pill.href = wa(n ? H.waMsgFor + n : H.waMsg); };
    link(); if (inp) inp.addEventListener('input', link);
    if (hero && order && 'IntersectionObserver' in window) {
      const seen = { hero: true, order: false };
      const sync = () => bar.classList.toggle('is-on', !seen.hero && !seen.order);
      new IntersectionObserver(es => es.forEach(e => { seen.hero = e.isIntersecting; sync(); }), { threshold: 0 }).observe(hero);
      new IntersectionObserver(es => es.forEach(e => { seen.order = e.isIntersecting; sync(); }), { threshold: .15 }).observe(order);
    } else if (!hero) bar.classList.add('is-on');
  }

  /* Living illustrations: a silent loop over each still, loaded and played only while on screen. */
  const afterLoad = fn => document.readyState === 'complete' ? fn() : addEventListener('load', () => setTimeout(fn, 300), { once: true });   // never compete with the cover (LCP)
  if (!matchMedia('(prefers-reduced-motion: reduce)').matches && !document.documentElement.classList.contains('a11y-still') && 'IntersectionObserver' in window) afterLoad(() => {
    document.querySelectorAll('video[data-live]').forEach(v => {
      new IntersectionObserver(es => es.forEach(e => {
        if (e.isIntersecting) {
          if (!v.src) { v.src = v.dataset.live; v.addEventListener('playing', () => v.classList.add('is-live'), { once: true }); }
          v.play().catch(() => {});
        } else if (v.src) v.pause();
      }), { rootMargin: '200px 0px' }).observe(v);
    });
  });

  /* The flipbook iframe gets its src only when the visitor comes near it (30 illustrated pages). */
  const f = document.querySelector('iframe[data-src], iframe[data-b64]');
  if (f) {
    const go = () => {
      if (f.dataset.b64) { if (!f.srcdoc) f.srcdoc = new TextDecoder().decode(Uint8Array.from(atob(f.dataset.b64), c => c.charCodeAt(0))); }
      else if (!f.src) f.src = f.dataset.src;
    };
    f.addEventListener('focus', go);
    if (!('IntersectionObserver' in window)) go();
    else { const io = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { go(); io.disconnect(); } }, { rootMargin: '150px 0px' }); io.observe(f); }
  }
})();

/* Scroll motion (27.10). Runs only when the head script set html.mo. The hero never moves. */
(() => {
  const root = document.documentElement;
  if (!root.classList.contains('mo')) return;
  const main = document.querySelector('main') || document.body;
  /* Shopify wraps every section in its own div, so look for top-level sections anywhere in main */
  const secs = [...main.querySelectorAll('section')].filter(s => !s.classList.contains('hero') && !s.parentElement.closest('section'));

  /* Words, never letters: Hebrew bidi breaks when a word is split. Punctuation-only tokens stay inline text so a line
     never breaks before "?" and they fade in with the word they follow. */
  const PUNCT = /^[\s  ]*[?!.,:;»«…"'״׳\-]+$/;
  const split = (el, cls) => {
    let n = 0;
    const walk = node => {
      [...node.childNodes].forEach(c => {
        if (c.nodeType === 1) { if (c.tagName !== 'BR') walk(c); return; }
        if (c.nodeType !== 3 || !c.textContent.trim()) return;
        const frag = document.createDocumentFragment();
        c.textContent.split(/([ \t\n]+)/).forEach(tok => {
          if (!tok) return;
          if (/^[ \t\n]+$/.test(tok)) { frag.append(' '); return; }
          if (PUNCT.test(tok)) { const p = document.createElement('span'); p.className = 'w__p'; p.style.setProperty('--i', Math.max(n - 1, 0)); p.textContent = tok; frag.append(p); return; }
          const w = document.createElement('span'), i = document.createElement('span');
          w.className = cls; i.className = cls + '__in'; i.style.setProperty('--i', n++); i.textContent = tok;
          w.append(i); frag.append(w);
        });
        c.replaceWith(frag);
      });
    };
    walk(el); el.style.setProperty('--n', n); return n;
  };

  const io = new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting) return;
    e.target.classList.add('is-in'); io.unobserve(e.target);   // once: an element that hides again on scroll-up feels broken
  }), { threshold: 0, rootMargin: '0px 0px -12% 0px' });
  const watch = (el, cls, i) => { el.classList.add(cls); if (i !== undefined) el.style.setProperty('--i', Math.min(i, 4)); io.observe(el); };

  const scrub = CSS.supports && CSS.supports('animation-timeline: view()');
  secs.forEach(sec => {
    sec.querySelectorAll('h2').forEach(h => { split(h, 'w'); watch(h, 'rv-h'); });
    const moment = sec.classList.contains('moment') && sec.querySelector('p');
    if (moment) { if (scrub) { split(moment, 'sw'); moment.classList.add('rv-scrub'); } else { split(moment, 'w'); watch(moment, 'rv-h'); } }
    sec.querySelectorAll('.eyebrow, .lead, .flip__open, .gal__hint, .occ__more, .plans__ship, .pano__cap, .stars3')
      .forEach(el => watch(el, 'rv'));
    sec.querySelectorAll('.steps, .get__list, .values, .topics, .occ__grid, .plans, .gal__strip, .faq').forEach(g => {
      [...g.children].filter(c => !['H2', 'SPAN'].includes(c.tagName) && !c.classList.contains('eyebrow'))
        .forEach((c, i) => watch(c, 'rv', i));
      if (g.classList.contains('steps')) watch(g, 'rv-line');
    });
    sec.querySelectorAll('.get__art, .flip__frame, .pano__frame, .moment__art, .trust__photo, .trust__sheet').forEach((el, i) => watch(el, 'rv-m', i));
  });
  /* the last lines of the page may never cross the trigger line: once the footer shows, everything left appears */
  const end = document.querySelector('footer');
  if (end) new IntersectionObserver((es, o) => { if (es.some(e => e.isIntersecting)) { document.querySelectorAll('.rv, .rv-h, .rv-m, .rv-line').forEach(el => el.classList.add('is-in')); o.disconnect(); } }).observe(end);
})();

/* Night sky (27.10): living stars on the night sections. The CSS stars stay underneath as the fallback. */
(() => {
  const hosts = [...document.querySelectorAll('.night > .stars')];
  if (!hosts.length || !window.HTMLCanvasElement) return;
  const still = matchMedia('(prefers-reduced-motion: reduce)').matches || document.documentElement.classList.contains('a11y-still');
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const GOLD = '255,214,90', WHITE = '255,255,255', TAU = Math.PI * 2;
  const rnd = (a, b) => a + Math.random() * (b - a);

  hosts.forEach(host => {
    const sec = host.parentElement, cv = document.createElement('canvas'), cx = cv.getContext('2d');
    if (!cx) return;
    cv.className = 'sky'; host.append(cv); host.classList.add('has-sky');
    const ov = document.createElement('canvas'), ox = ov.getContext('2d');   // sparkle bursts paint ABOVE the content: behind the book they were hidden
    ov.className = 'sky-fx'; ov.setAttribute('aria-hidden', 'true'); sec.append(ov);
    let W = 0, Hh = 0, stars = [], fx = [], shots = [], px = 0, py = 0, tx = 0, ty = 0, on = false, raf = 0, nextShot = 0;

    const size = () => {
      const dpr = Math.min(devicePixelRatio || 1, 2);
      W = sec.clientWidth; Hh = sec.clientHeight;
      cv.width = ov.width = Math.round(W * dpr); cv.height = ov.height = Math.round(Hh * dpr);
      cx.setTransform(dpr, 0, 0, dpr, 0, 0); ox.setTransform(dpr, 0, 0, dpr, 0, 0);
      const n = Math.round(Math.max(60, Math.min(220, W * Hh / 6500)));
      stars = Array.from({ length: n }, () => {
        const z = Math.random() ** 1.6;   // most stars far and small, a few near and bright
        return { x: rnd(0, W), y: rnd(0, Hh), z, r: .45 + z * 1.6, gold: Math.random() < .28, sp: rnd(.5, 2.4), ph: rnd(0, TAU),
                 a: .3 + z * .65, spark: z > .82 && Math.random() < .6 };
      });
      if (still || !on) draw(performance.now());
    };

    const sparkle = (x, y, r, al, rgb, g = cx) => {   // a soft 4-point star: two thin diamonds and a glow
      g.fillStyle = `rgba(${rgb},${al * .18})`; g.beginPath(); g.arc(x, y, r * 3.2, 0, TAU); g.fill();
      g.fillStyle = `rgba(${rgb},${al})`; g.beginPath();
      const L = r * 4.2, w = r * .55;
      g.moveTo(x, y - L); g.lineTo(x + w, y - w); g.lineTo(x + L, y); g.lineTo(x + w, y + w);
      g.lineTo(x, y + L); g.lineTo(x - w, y + w); g.lineTo(x - L, y); g.lineTo(x - w, y - w); g.closePath(); g.fill();
    };

    const draw = t => {
      cx.clearRect(0, 0, W, Hh);
      px += (tx - px) * .05; py += (ty - py) * .05;
      const b = sec.getBoundingClientRect(), scroll = fine ? 0 : Math.min(0, b.top);   // phones: layers slide at different speeds while scrolling
      for (const s of stars) {
        const tw = still ? .8 : .55 + .45 * Math.sin(t / 1000 * s.sp + s.ph);
        let x = (s.x + (still ? 0 : t * .004 * (.3 + s.z)) - px * s.z * 26) % W; if (x < 0) x += W;
        let y = (s.y - py * s.z * 16 - scroll * s.z * .22) % Hh; if (y < 0) y += Hh;
        const al = s.a * tw, rgb = s.gold ? GOLD : WHITE;
        if (s.spark) sparkle(x, y, s.r * .7, al, rgb);
        else { cx.fillStyle = `rgba(${rgb},${al})`; cx.beginPath(); cx.arc(x, y, s.r, 0, TAU); cx.fill(); }
      }
      if (still) return;
      if (t > nextShot) { shoot(rnd(W * .15, W * .95), rnd(0, Hh * .35)); nextShot = t + rnd(4500, 9000); }
      shots = shots.filter(s => (s.life -= 16) > 0);
      for (const s of shots) {
        s.x += s.vx; s.y += s.vy;
        const k = s.life / s.max, g = cx.createLinearGradient(s.x, s.y, s.x - s.vx * 16, s.y - s.vy * 16);
        g.addColorStop(0, `rgba(255,236,170,${k})`); g.addColorStop(1, 'rgba(255,236,170,0)');
        cx.strokeStyle = g; cx.lineWidth = 1.8; cx.lineCap = 'round';
        cx.beginPath(); cx.moveTo(s.x, s.y); cx.lineTo(s.x - s.vx * 16, s.y - s.vy * 16); cx.stroke();
        sparkle(s.x, s.y, 1.1, k, GOLD);
      }
      ox.clearRect(0, 0, W, Hh);
      fx = fx.filter(p => (p.life -= 16) > 0);
      for (const p of fx) {
        p.x += p.vx; p.y += p.vy; p.vy += .035; p.vx *= .985;
        const k = p.life / p.max;
        sparkle(p.x, p.y, p.r * (.4 + k * .6), k, p.gold ? GOLD : WHITE, ox);
      }
    };
    const shoot = (x, y) => { const sp = rnd(7, 11), ang = rnd(2.45, 2.75); shots.push({ x, y, vx: Math.cos(ang) * sp, vy: Math.sin(ang) * sp, life: 900, max: 900 }); };
    const burst = (x, y, n) => {
      for (let i = 0; i < n; i++) { const a = rnd(0, TAU), v = rnd(.8, 3.6);
        fx.push({ x, y, vx: Math.cos(a) * v, vy: Math.sin(a) * v - 1.2, r: rnd(1, 2.4), gold: Math.random() < .75, life: rnd(600, 1300), max: 1300 }); }
      if (fx.length > 260) fx.splice(0, fx.length - 260);
      wake();
    };

    const loop = t => { draw(t); raf = on && !document.hidden ? requestAnimationFrame(loop) : 0; };
    const wake = () => { if (!raf && on && !document.hidden) raf = requestAnimationFrame(loop); };
    new ResizeObserver(size).observe(sec);
    if (still) return;
    new IntersectionObserver(es => { on = es[0].isIntersecting; wake(); }).observe(sec);
    document.addEventListener('visibilitychange', wake);
    if (fine) sec.addEventListener('pointermove', e => { const r = sec.getBoundingClientRect(); tx = (e.clientX - r.left) / r.width * 2 - 1; ty = (e.clientY - r.top) / r.height * 2 - 1; });
    sec.addEventListener('pointerdown', e => {   // a tap on the sky itself, never on a control or the book
      if (e.target.closest('a, button, input, label, select, textarea, .book3d, form')) return;
      const r = sec.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top;
      burst(x, y, 22); shoot(x, y);
    });
    const name = sec.querySelector('#try-name'), on_cover = sec.querySelector('.book3d__name');
    if (name && on_cover) name.addEventListener('input', () => {   // every letter of the child's name sparkles on the cover
      const r = sec.getBoundingClientRect(), c = on_cover.getBoundingClientRect();
      burst(c.left + c.width / 2 - r.left, c.top + c.height / 2 - r.top, 14);
    });
  });
})();

/* Section interactions (27.10). Only when motion is allowed (html.mo). */
(() => {
  if (!document.documentElement.classList.contains('mo')) return;
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* 1. how it works: sticky heading, counter, gold bar, active step = the one crossing the middle of the screen */
  const how = document.getElementById('how'), steps = how && how.querySelector('.steps');
  if (steps) {
    const wrap = steps.parentElement, head = document.createElement('div'), items = [...steps.children], N = items.length;
    head.className = 'how__head';
    // 31.10: the "one child" block stays after the steps (full width), only the heading goes into the sticky column
    [...wrap.children].filter(c => c !== steps && !c.classList.contains('one')).forEach(c => head.append(c));
    const count = document.createElement('p'), bar = document.createElement('span');
    count.className = 'how__count'; count.dir = 'ltr'; count.setAttribute('aria-hidden', 'true');
    bar.className = 'how__bar'; bar.setAttribute('aria-hidden', 'true'); bar.append(document.createElement('i'));
    head.append(count, bar); wrap.prepend(head); wrap.classList.add('how-sticky');
    const pad = n => String(n).padStart(2, '0');
    const set = i => { items.forEach((s, k) => s.classList.toggle('is-active', k === i)); count.innerHTML = `<b>${pad(i + 1)}</b> / ${pad(N)}`; bar.style.setProperty('--p', (i + 1) / N); };
    set(0);
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) set(items.indexOf(e.target)); }), { rootMargin: '-45% 0px -45% 0px' });
    items.forEach(s => io.observe(s));
  }

  /* 2. the three stars of "the moment": one span each, lit by the scroll (CSS) */
  const s3 = document.querySelector('.moment .stars3');
  if (s3) s3.innerHTML = [...s3.textContent.trim()].map((c, i) => `<span class="s3" style="--i:${i}">${c}</span>`).join('');

  /* 3. gallery: drag to scroll with a mouse; a drag never turns into a click */
  const strip = document.querySelector('.gal__strip');
  if (strip) {   /* the page nearest the strip's centre is in focus (a CSS view(inline) timeline mis-measured this RTL strip) */
    const figs = [...strip.children]; let tick = 0;
    const focus = () => { tick = 0; const r = strip.getBoundingClientRect(), mid = r.left + r.width / 2;
      let best = null, d0 = 1e9; figs.forEach(f => { const b = f.getBoundingClientRect(), d = Math.abs(b.left + b.width / 2 - mid); if (d < d0) { d0 = d; best = f; } });
      figs.forEach(f => f.classList.toggle('is-focus', f === best)); };
    strip.addEventListener('scroll', () => { if (!tick) tick = requestAnimationFrame(focus); }, { passive: true });
    addEventListener('resize', focus); focus(); strip.classList.add('has-focus');
  }
  if (strip && fine) {
    let down = false, moved = false, x0 = 0, s0 = 0;
    strip.addEventListener('pointerdown', e => { if (e.button) return; down = true; moved = false; x0 = e.clientX; s0 = strip.scrollLeft; });
    addEventListener('pointermove', e => {
      if (!down) return; const dx = e.clientX - x0;
      if (!moved && Math.abs(dx) > 5) { moved = true; strip.classList.add('is-drag'); }
      if (moved) strip.scrollLeft = s0 - dx;   // the page follows the hand, in RTL and LTR alike
    });
    addEventListener('pointerup', () => { if (down) { down = false; strip.classList.remove('is-drag'); } });
    strip.addEventListener('click', e => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    strip.addEventListener('dragstart', e => e.preventDefault());
  }

  /* 4. packages: once a plan has appeared, hand it back to its own styles (so the hover lift works) and shine the tag once */
  document.querySelectorAll('.plans > .plan').forEach(p => p.addEventListener('transitionend', function done(e) {
    if (e.target !== p || e.propertyName !== 'transform' || !p.classList.contains('is-in')) return;
    p.removeEventListener('transitionend', done); p.classList.remove('rv', 'is-in');
    const tag = p.querySelector('.plan__tag'); if (tag) tag.classList.add('is-shine');
  }));
})();

/* Accessibility menu (28.10): options are classes on <html>, remembered; "stop animations" reloads so nothing is half-running. */
(() => {
  const box = document.getElementById('a11y'); if (!box) return;
  const btn = box.querySelector('.a11y__btn'), panel = box.querySelector('.a11y__panel'), KEY = 'historia_a11y', h = document.documentElement;
  let on = []; try { on = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}
  const sync = () => box.querySelectorAll('[data-a11y]').forEach(b => b.setAttribute('aria-pressed', on.includes(b.dataset.a11y)));
  const save = () => { try { localStorage.setItem(KEY, JSON.stringify(on)); } catch (e) {} };
  const open = v => { panel.hidden = !v; btn.setAttribute('aria-expanded', v); if (v) panel.querySelector('[data-a11y]').focus(); };
  btn.addEventListener('click', () => open(panel.hidden));
  box.querySelector('.a11y__x').addEventListener('click', () => { open(false); btn.focus(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && !panel.hidden) { open(false); btn.focus(); } });
  document.addEventListener('click', e => { if (!panel.hidden && !box.contains(e.target)) open(false); });
  box.querySelectorAll('[data-a11y]').forEach(b => b.addEventListener('click', () => {
    const k = b.dataset.a11y, was = on.includes(k);
    on = was ? on.filter(x => x !== k) : on.concat(k); h.classList.toggle('a11y-' + k, !was); save(); sync();
    if (k === 'still') location.reload();
  }));
  box.querySelector('.a11y__reset').addEventListener('click', () => {
    const still = on.includes('still'); on.forEach(k => h.classList.remove('a11y-' + k)); on = []; save(); sync();
    if (still) location.reload();
  });
  sync();
})();

/* The child's name across the page + "send the cover to grandma" (28.10). The name lives in sessionStorage. */
(() => {
  const H = window.HISTORIA || {}, inp = document.getElementById('try-name'), KEY = 'historia_name', fr = document.documentElement.lang === 'fr';
  const get = () => { try { return sessionStorage.getItem(KEY) || ''; } catch (e) { return ''; } };
  const keep = v => { try { v ? sessionStorage.setItem(KEY, v) : sessionStorage.removeItem(KEY); } catch (e) {} };
  const ctas = [...document.querySelectorAll('.hero__ctas .btn, .order__ctas .btn, .sticky-cta__order')]
    .filter(a => /\/products\/personal-book/.test(a.getAttribute('href') || ''));
  ctas.forEach(a => { a.dataset.label = a.textContent.trim(); a.dataset.href = a.getAttribute('href'); });
  let share = null;
  const apply = n => {
    ctas.forEach(a => {
      const tpl = a.classList.contains('sticky-cta__order') ? H.stickyFor : H.ctaFor;
      a.textContent = n && tpl ? tpl.replace('{n}', n) : a.dataset.label;
      const u = new URL(a.dataset.href, location.href); if (n) u.searchParams.set('name', n);
      a.setAttribute('href', u.pathname + u.search);
    });
    if (share) share.hidden = !n;
  };

  /* the shared picture: the cover as on the page, the name drawn like the page draws it, and an "example" band */
  const coverImage = async n => {
    const cover = document.querySelector('.book3d__cover'), pic = cover && cover.querySelector('img');
    if (!pic) throw new Error('no cover');
    if (document.fonts && document.fonts.ready) await document.fonts.ready;
    const img = new Image(); img.src = pic.currentSrc || pic.src; await img.decode();
    const W = 1080, ih = Math.round(W * img.naturalHeight / img.naturalWidth), band = 110, s = W / cover.offsetWidth;
    const c = document.createElement('canvas'); c.width = W; c.height = ih + band; const g = c.getContext('2d');
    g.fillStyle = '#1b1f45'; g.fillRect(0, 0, W, ih + band); g.drawImage(img, 0, 0, W, ih);
    const title = cover.querySelector('.book3d__title'), of = cover.querySelector('.book3d__of'), nm = cover.querySelector('.book3d__name');
    const cx = (title.offsetLeft + title.offsetWidth / 2) * s;
    g.textAlign = 'center'; g.textBaseline = 'top'; g.direction = fr ? 'ltr' : 'rtl';
    const fOf = parseFloat(getComputedStyle(of).fontSize) * s;
    g.font = `600 ${fOf}px Fredoka, sans-serif`; g.fillStyle = '#fff6dc'; g.shadowColor = 'rgba(20,10,60,.7)'; g.shadowBlur = fOf * .5;
    g.fillText(H.shareOf || '', cx, (title.offsetTop + of.offsetTop) * s);
    const fN = parseFloat(getComputedStyle(nm).fontSize) * s, y = (title.offsetTop + nm.offsetTop) * s;
    g.font = `700 ${fN}px Fredoka, sans-serif`; g.lineJoin = 'round';
    g.shadowColor = 'rgba(10,6,40,.55)'; g.shadowBlur = fN * .2; g.shadowOffsetY = fN * .12;
    g.strokeStyle = '#5b2a12'; g.lineWidth = fN * .09; g.strokeText(n, cx, y);
    g.shadowColor = 'transparent'; g.fillStyle = '#ffd04a'; g.fillText(n, cx, y);
    g.font = '500 34px Fredoka, sans-serif'; g.fillStyle = 'rgba(255,255,255,.88)'; g.textBaseline = 'middle';
    g.fillText(H.shareTag || 'historiabooks.com', W / 2, ih + band / 2);
    return new Promise(r => c.toBlob(r, 'image/jpeg', .9));
  };

  const box = inp && inp.closest('.try');
  if (box && H.shareBtn) {
    share = document.createElement('button');
    share.type = 'button'; share.className = 'share-cover'; share.hidden = true;
    const ico = document.querySelector('.wa-float__icon svg');
    share.innerHTML = (ico ? `<span class="share-cover__ico" aria-hidden="true">${ico.outerHTML}</span>` : '') + `<span>${H.shareBtn}</span>`;
    box.after(share);
    share.addEventListener('click', async () => {
      const n = inp.value.trim(); if (!n) return;
      const text = H.shareText.replace('{n}', n) + '\n' + location.origin + (fr ? '/fr' : '');
      try {
        const blob = await coverImage(n), file = new File([blob], 'historia.jpg', { type: 'image/jpeg' });
        if (navigator.canShare && navigator.canShare({ files: [file] })) { await navigator.share({ files: [file], text }); return; }
      } catch (e) { if (e && e.name === 'AbortError') return; }
      window.open('https://wa.me/?text=' + encodeURIComponent(text), '_blank', 'noopener');   // desktop: the text and the link
    });
    window.historiaCoverImage = coverImage;   // for QA: lets a test render the picture without sharing it
  }

  if (inp) {
    const saved = get();
    if (saved && !inp.value) { inp.value = saved; inp.dispatchEvent(new Event('input')); }
    inp.addEventListener('input', () => { const n = inp.value.trim(); keep(n); apply(n); });
  }
  apply(get());
})();

/* 31.10 our ads: a poster until tapped, then the video plays inline with sound; starting one pauses the others */
(() => {
  document.querySelectorAll('.vid__play[data-video]').forEach(btn => btn.addEventListener('click', () => {
    const v = document.createElement('video');
    v.src = btn.dataset.video; v.poster = btn.querySelector('img').src;
    v.controls = true; v.playsInline = true; v.preload = 'auto'; v.className = 'vid__v';
    v.setAttribute('aria-label', btn.getAttribute('aria-label'));
    v.addEventListener('play', () => document.querySelectorAll('.vid__v').forEach(o => { if (o !== v) o.pause(); }));
    btn.replaceWith(v); v.play().catch(() => {});
  }));
})();
